'use client';

import { ContractAddresses, TestnetBadge } from '#/modules/contract-addresses';
import { Translation } from 'intl-lib';
import { CreateEthereumStakingButton } from './modules/create-ethereum-staking-button';

export default function Page() {
  return (
    <>
      <div className="flex flex-col @5xl:flex-row justify-between gap-2">
        <div className="flex flex-col gap-2">
          <h2 className="text-3xl tracking-tight font-bold text-gray-900 dark:text-white">
            <Translation path="my_staking.Heading.Title" /> <TestnetBadge />
          </h2>
          <ContractAddresses />
        </div>
        <div>
          <CreateEthereumStakingButton />
        </div>
      </div>
    </>
  );
}
